import { useState } from "react";
import { MessageCircle, X, CalendarCheck, HeartPulse, AlertTriangle, Headset } from "lucide-react";
import { whatsappLink } from "@/lib/constants";

const INTENTS = [
    { key: "book", icon: CalendarCheck, label: "Book a service", desc: "Electrician, plumber, AC & more", msg: "Hi HOMIIE 👋 I'd like to book a home service. Please help me get started." },
    { key: "care", icon: HeartPulse, label: "HOMIIE Care help", desc: "Elder-care plans, visits & health", msg: "Hi HOMIIE Care 👋 I have a question about elder-care plans / visits for my parents." },
    { key: "problem", icon: AlertTriangle, label: "Report a problem", desc: "Booking, payment or service issue", msg: "Hi HOMIIE 👋 I'm facing an issue with my booking/service and need help resolving it." },
    { key: "support", icon: Headset, label: "Talk to support", desc: "Anything else about my home", msg: "Hi HOMIIE 👋 I need help with my home." },
];

export function WhatsAppAssistant({ accent = "services", drawerItemClass, iconClass }) {
    const [open, setOpen] = useState(false);
    const coral = accent === "care";
    const brand = coral ? "#F43F5E" : "#009C95";

    const go = (msg) => { window.open(whatsappLink(msg), "_blank"); setOpen(false); };

    return (
        <>
            <button data-testid="menu-whatsapp-bot" onClick={() => setOpen(true)} className={drawerItemClass}>
                <MessageCircle size={18} className={iconClass} /> WhatsApp Assistant
            </button>

            {open && (
                <div className="fixed inset-0 z-[80] flex items-end justify-center bg-navy/50" onClick={() => setOpen(false)}>
                    <div className="w-full max-w-md rounded-t-3xl bg-white p-6 pb-8" onClick={(e) => e.stopPropagation()} data-testid="whatsapp-assistant-sheet">
                        <div className="mb-1 flex items-center justify-between">
                            <div className="flex items-center gap-2">
                                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-emerald-500"><MessageCircle size={18} className="text-white" /></span>
                                <div>
                                    <h3 className="font-heading text-lg font-extrabold leading-none text-navy">WhatsApp Assistant</h3>
                                    <p className="mt-0.5 text-[11px] text-navy/50">Service & Care help, 24×7</p>
                                </div>
                            </div>
                            <button data-testid="whatsapp-assistant-close" onClick={() => setOpen(false)} className="rounded-full bg-navy/5 p-1.5"><X size={16} /></button>
                        </div>
                        <p className="mt-2 text-sm text-navy/60">What can we help you with? We'll open WhatsApp with your message ready.</p>
                        <div className="mt-4 space-y-2.5">
                            {INTENTS.map((it) => {
                                const Ic = it.icon;
                                return (
                                    <button key={it.key} data-testid={`whatsapp-intent-${it.key}`} onClick={() => go(it.msg)} className="flex w-full items-center gap-3 rounded-2xl border border-navy/10 p-3.5 text-left transition-transform active:scale-[0.98]">
                                        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl" style={{ backgroundColor: `${brand}1a`, color: brand }}><Ic size={18} /></span>
                                        <div className="flex-1"><p className="font-heading text-sm font-bold text-navy">{it.label}</p><p className="text-xs text-navy/50">{it.desc}</p></div>
                                        <MessageCircle size={16} className="text-emerald-500" />
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
